import React from 'react';
import { btnStyle } from '../PlateStyles';
import { formatirajDatumSRB } from '../PlateUtils';

const DeleteConfirmModal = ({ datum, onConfirm, onClose }) => (
    <div style={{position: 'fixed', top:0, left:0, width:'100%', height:'100%', backgroundColor:'rgba(0,0,0,0.9)', display:'flex', justifyContent:'center', alignItems:'center', zIndex: 10000}}>
        <div style={{backgroundColor:'#0a132b', padding:'30px', borderRadius:'10px', width:'400px', border:'1px solid #ff4444', textAlign: 'center'}}>
            <h3 style={{color: 'white'}}>Potvrda brisanja</h3>
            <p style={{color: 'white'}}>
                Obriši red za <strong>{formatirajDatumSRB(datum)}</strong>?
            </p>
            <div style={{display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '20px'}}>
                <button onClick={onClose} style={{...btnStyle, backgroundColor: '#666', color: 'white'}}>Odustani</button>
                <button 
                    onClick={onConfirm} 
                    style={{...btnStyle, backgroundColor: '#ff4444', color: 'white'}}
                >
                    Obriši
                </button>
            </div>
        </div>
    </div>
);

export default DeleteConfirmModal;